module.exports = __webpack_public_path__ + "static/media/certi.774b88b7.svg";